import type { UserPermission } from '@contracts/users/UserPermission';

interface Attributes {
  id: string;
  email: string;
  name: string;
  permissions: UserPermission[];
}

export class AuthenticatedUser {
  public id: string;
  public name: string;
  public email: string;
  public permissions: UserPermission[];
  constructor({ id, name, email, permissions }: Attributes) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.permissions = permissions;
  }
}
